<template>
  <div class="card">
    <div class="mark"></div>
  </div>
</template>

<script>
export default {
  name: 'ProductLoader',
  props: {
    data: Object
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.card{
  background-color: darken(#f9f9f9, 3%);
  padding-bottom: 150px;
  height: 520px;
  overflow: hidden;
  position: relative;
  @include radius(10px);

  @include responsive(mobile){
    height: 300px;
  }

  @keyframes slide {
    0% { @include transform(translateX(-50%) translateY(-200%) translateZ(0)); }
    100% { @include transform(translateX(-50%) translateY(200%) translateZ(0)); }
  }

  .mark{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    animation: slide 1s linear infinite;
    background: rgb(15,242,32);
    background: linear-gradient(0deg, rgba(darken(#f9f9f9, 3%), 1) 0%, rgba(darken(#f9f9f9, 6%), 1) 50%, rgba(darken(#f9f9f9, 3%), 1) 100%);
    @include transform(translateX(-50%) translateY(-50%) translateZ(0));
  }
}
</style>
